import _ from 'lodash';
import { createSelector } from 'reselect';

const selectAppKeysState = state => state.system.appKeys;

export const selectAppKeys = createSelector(selectAppKeysState, appKeysState =>
  _.values(appKeysState.data || {}),
);
